<template>
  <div class="study-resources">
    <div class="tags">
      <span class="tag">
        <app-date
          prepend="Deadline"
          :date="$store.state.study.deadline"
        ></app-date>
      </span>
    </div>
    <study-information :content="compiledMarkdown" />
    <hr />
    <study-references />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import marked from 'marked';
import StudyInformation from '@/components/art-club/study/resources/StudyInformation';
import StudyReferences from '@/components/art-club/study/resources/StudyReferences';
import AppDate from '@/components/app/AppDate';

export default {
  name: 'art-club-study-resources',
  components: { StudyInformation, StudyReferences, AppDate },
  data() {
    return {
      status: 'loading',
    };
  },
  methods: {
    ...mapActions('study', ['getReferences']),
  },
  computed: {
    ...mapState('study', {
      description: state => state.description,
    }),
    compiledMarkdown: function() {
      return marked(this.description);
    },
  },
};
</script>

<style lang="scss" scoped>
.tags {
  .tag {
    margin-right: 1rem;
  }
}
.tag {
  display: inline-flex;
  color: color('primary', 'text');
  background: color('primary');
  padding: 4px 8px;
  border-radius: 4px;

  &.secondary {
    background: color('secondary');
    color: color('secondary', 'text');
  }
}
</style>
